// React Lib
import React from "react";
// Component Styles
import { useStyles } from "./SystemMessageStyles";
// @otg-one/ui_components/components
import { Typography, Chip, Separator } from "../index";
// @otg-one/ui_components/constants
import { Color, FONT_FAMILY } from "../../constants";
// Material UI Core
import Grid from '@mui/material/Grid';
const SystemMessageList = (props) => {
    const classes = useStyles(props);
    const { id, log, style } = props;
    return (React.createElement("div", { className: classes.systemMessageList, style: style },
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, md: 1, style: { textAlign: "center" } },
                React.createElement(Chip, { backgroundColor: Color.neutral[900], color: Color.neutral[0] }, log.log_type)),
            React.createElement(Grid, { item: true, md: 7 },
                React.createElement(Typography, { id: `${id}-system-message`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[0] }, log.messages)),
            React.createElement(Grid, { item: true, md: 2 },
                React.createElement(Typography, { id: `${id}-system-message-date`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[0] }, log.date)),
            React.createElement(Grid, { item: true, md: 2 },
                React.createElement(Typography, { id: `${id}-system-message-time`, fontFamily: FONT_FAMILY.ROBOTO_REGULAR, size: 14, color: Color.neutral[0] }, log.time)))));
};
export const SystemMessage = (props) => {
    const classes = useStyles(props);
    const { id, log, style, systemMessageListStyle, textSystemMessages, handleViewMore, textViewMore } = props;
    return (React.createElement("div", { id: id, className: classes.systemMessageContainer, style: style },
        React.createElement("div", { className: classes.systemMessageHeaderContainer },
            React.createElement(Typography, { id: `${id}-system-message-title`, fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.neutral[0] }, textSystemMessages),
            handleViewMore &&
                React.createElement(Typography, { fontFamily: FONT_FAMILY.ROBOTO_MEDIUM, size: 16, color: Color.primary[600], style: { cursor: "pointer" }, onClick: handleViewMore }, textViewMore)),
        React.createElement("div", { id: `${id}-system-message-container`, className: classes.systemMessageListContainer }, log.map((l, index) => (React.createElement(React.Fragment, { key: `l${index}` },
            React.createElement(SystemMessageList, { key: `${l.messages}-${index}`, id: `${id}-${index}`, log: l, style: systemMessageListStyle }),
            index !== log.length - 1 && React.createElement(Separator, { type: "n100" })))))));
};
SystemMessage.defaultProps = {
    messages: [],
    log: [],
    textSystemMessages: 'System Messages',
    textViewMore: 'View More',
};
export default React.memo(SystemMessage);
